import { FC, ReactNode } from "react";
export const Card: FC<{
  children: ReactNode;
  className?: string;
}> = ({ children, className = "" }) => {
  return (
    <div
      className={`font-body tracking-wider bg-white rounded-lg border shadow-sm overflow-hidden p-4 pt-8 ${className}`}
    >
      {children}
    </div>
  );
};
